// ======================================================================
// File Name       : userHistoryCourse
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const USER_HISTORY_COURSE_INIT_SEARCH_INPUT = 'USER_HISTORY_COURSE_INIT_SEARCH_INPUT';
export const USER_HISTORY_COURSE_RECEIVED_SEARCH_RESULT = 'USER_HISTORY_COURSE_RECEIVED_SEARCH_RESULT';
export const USER_HISTORY_COURSE_RECEIVED_COURSE_DETAIL = 'USER_HISTORY_COURSE_RECEIVED_COURSE_DETAIL';
// #7386 START
export const USER_HISTORY_COURSE_RECEIVED_PIE_CHART_DATA = 'USER_HISTORY_COURSE_RECEIVED_PIE_CHART_DATA';
export const USER_HISTORY_COURSE_RECEIVED_BAR_CHART_DATA = 'USER_HISTORY_COURSE_RECEIVED_BAR_CHART_DATA';
// #7386 END
